import React, { Suspense, useState, useEffect } from "react";
import 'react-responsive-modal/styles.css';
import Drawer from 'react-modern-drawer';   
import { CommonUtilities } from "../../commonUtils";

export default function StatementSetting(param:any) { 
  
    const[resume, setresume]                    = useState(0);
    const[contract, setcontract]                = useState(0);
    const[contactNoEmail, setcontactNoEmail]    = useState(2);

    const updateControllerSettings  = (variable : any, value  : any) => { 

        console.log(value)
        if (variable === 'Contracts') { 

            setcontract(value === 1 ? 0 : 1);
        }

        if (variable === 'Missing') {
            setresume(value === 1 ? 0 : 1); 
        }

        if (variable === 'Email') {
            setcontactNoEmail(value);
        }

    };

    const StatementSettingClose =()=>{
        var payload = {
            resume          : resume,
            contract        : contract,
            contactNoEmail  : contactNoEmail
        }
        param.StatementSettingClose(payload);
    } 
 
    return (
        <>
        <Drawer open={param.openStatementSetting} onClose={() => StatementSettingClose()} direction={"right"}>
            <div className="box noBorderRadius noBorder ws-6 pull-right">

                <div className="box-header-main"><h2>Statements Settings</h2></div>

                <div className="box-content">

                    <div className="ws-12">

                        <div className="ws-12 landing">
                            <div className="ws-4 pm">
                                <div className="pLarge topFrame topFrame_paleBlue ws-12 pull-left" style={{minHeight:"80px"}}>
                                    <label className="ws-12 text-left mts text-bold" >Project title:</label>
                                    <div className="label-entries text-right ws-12 mtl mb">
                                        ALLCONTRACTS
                                    </div>
                                </div>
                            </div>

                            <div className="ws-4 pm">
                                <div className="pLarge topFrame topFrame_paleBlue ws-12 pull-left" style={{minHeight:"80px"}}>
                                    <label className="ws-12 text-left mts text-bold" >Project Code:</label>
                                    <div className="label-entries text-right ws-12 mtl mb">
                                        M00005_ALLC
                                    </div>
                                </div>
                            </div>

                            <div className="ws-4 pm">
                                <div className="pLarge topFrame topFrame_paleBlue ws-12 pull-left" style={{minHeight:"80px"}}>
                                    <label className="ws-12 text-left mts text-bold" >Project Status</label>
                                    <div className="label-entries text-left ws-12 mtl mb mll">

                                        <a className="btn-xs m0 mrs" style={{ background: CommonUtilities.lookUpTypeList("projectTag",  CommonUtilities.lookUpTypeListByKey("ProjectStatus",  param?.projectDetails?.status, "value"), 'bgColor'), 
                                            color: CommonUtilities.lookUpTypeList("projectTag",  CommonUtilities.lookUpTypeListByKey("ProjectStatus",  param?.projectDetails?.status, "value"), 'fontColor') }}>
                                            {CommonUtilities.lookUpTypeListByKey("ProjectStatus",  param?.projectDetails?.status, "value")}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>            
                        
                        <div className="ws-12" style={{marginLeft: "35%"}}>
                            <div className="form-format ws-12 mtll">
                                <div className="label-entries">
                                    <div className="ws-12 mll pl">Use settings from the Contract(s)</div>
                                    <label className="switch mr mtl" style={{marginLeft: "20% !important"}}>
                                        <input type="checkbox" onClick={(e)=> updateControllerSettings('Contracts', contract)} checked={contract ==1}/>
                                        {contract === 1 && <span className="slider round text-left white pm pts">Yes</span>}
                                        {contract === 0 && <span className="slider round text-right white pm pts sliderOff">No</span>} 
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div className="ws-12" style={{marginLeft: "35%"}}>
                            <div className="form-format ws-12 mtll">
                                <div className="label-entries">
                                    <div className="ws-12 mll">Only Generate All Missing Statements / Excel</div>
                                    <label className="switch mr mtl" style={{marginLeft: "20% !important"}}>
                                        <input type="checkbox" data-ng-model="resume" onClick={()=> updateControllerSettings('Missing', resume)} checked={resume ==1}/>
                                        {resume === 1 && <span className="slider round text-left white pm pts">Yes</span>}
                                        {resume === 0 && <span className="slider round text-right white pm pts sliderOff">No</span>} 
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div className="ws-12 mtl" style={{marginLeft: "35%"}}>
                            <div className="ws-12 pll"> Include Contracts with no Email address </div>

                            <div className="pll" style={{marginLeft: "10%"}}>

                                <div className="triSelectContainer mtl pull-left">
                                    <label className="triSelect">
                                        <input type="radio" className="yes " name="radio" checked={contactNoEmail === 1} style={{display:"none"}}/>
                                        <div className="checkmark" onClick={()=> updateControllerSettings('Email', 1)}>
                                            <i className="icon-checkmark2"></i>
                                        </div>
                                    </label>
                                    <label className="triSelect">
                                        <input type="radio" className="neutral" name="radio" checked={contactNoEmail === 2} style={{display:"none"}}/>
                                        <div className="checkmark" onClick={()=> updateControllerSettings('Email', 2)}>
                                            <i className="icon-filled-circle" data-ng-click="contactNoEmail = 2"></i>
                                        </div>
                                    </label>
                                    <label className="triSelect">
                                        <input type="radio" className="no " name="radio" checked={contactNoEmail === 0} style={{display:"none"}}/>
                                        <div className="checkmark" onClick={()=> updateControllerSettings('Email', 0)}>
                                            <i className="icon-cancel2"></i>
                                        </div>
                                    </label>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>

                <div className="box-footer">
                    <button className="icon-btn delete pull-right" onClick={()=>StatementSettingClose()}>Close </button>
                </div>

            </div>
        </Drawer>
        </>
    )
}